interface CustomTagProps {
  color?: string;
  label: string;
}

export function CustomTag({ color = "transparent", label }: CustomTagProps) {
  return (
    <div
      style={{
        width: "138px",
        padding: "5px 0px",
        borderRadius: "5px",
        backgroundColor: color,
        display: "flex",
        justifyContent: "center",
      }}
    >
      <span style={{ color: "#fff" }}>{label}</span>
    </div>
  );
}
